module.exports = __webpack_public_path__ + "static/img/special-price.3fbe644.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product-detail/special-price.png
// module id = Mu6E
// module chunks = 4